import { render, staticRenderFns } from "./guide-download-tmp.vue?vue&type=template&id=be3a22fa&scoped=true&"
import script from "./guide-download-tmp.vue?vue&type=script&lang=ts&"
export * from "./guide-download-tmp.vue?vue&type=script&lang=ts&"
import style0 from "./guide-download-tmp.vue?vue&type=style&index=0&id=be3a22fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3a22fa",
  null
  
)

export default component.exports